const React = require("react");

require("./HttpResponse.less");

const Response = require("~/types/Response.js");

const HttpResponse = React.createClass({
    propTypes: {
        Response: Response.PropType.isRequired
    },
    render() {
        return (<div className="cs-HttpResponse">
            {this.props.Response.status} - {this.props.Response.statusText}
            <br />
            URL: {this.props.Response.url}
        </div>);
}
});

module.exports = HttpResponse;


// WEBPACK FOOTER //
// ./src/components/HttpResponse/HttpResponse.jsx